module.exports = "/virtual-football-league/img/amblems/left/Spain/Fake_Barcelona.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/left/Spain/Fake_Barcelona.png
// module id = 2046
// module chunks = 4